import { VisitDataHeaderAttributesCard } from '@planning/pages/VesselVisit/Components/molecules/VisitDataHeaderAttributesCard'
import { useTranslate } from '@tolgee/react'
import { HeightIcon, LengthIcon } from '@tom-ui/ui'
import { FC } from 'react'

export type ContainerRequirements = {
  operatorName: string
  archetypeName?: string | null | undefined
  containerLengths?: number[] | null | undefined
  containerHeights?: string[] | null | undefined
  containerTypes?: string[] | null | undefined
}

export type ContainerRequirementsStackProps = {
  containerRequirements: ContainerRequirements
  width?: string
  hideTitle?: boolean
}

export const ContainerRequirementsStack: FC<ContainerRequirementsStackProps> = ({
  containerRequirements,
  width = 'auto',
  hideTitle = false,
}) => {
  const { t } = useTranslate()

  return (
    <VisitDataHeaderAttributesCard
      title={hideTitle ? '' : t('containerRequirements', 'Container requirements')}
      width={width}
      attributes={[
        {
          label: t('operator', 'Operator'),
          value: containerRequirements.operatorName,
        },
        {
          label: t('archetype', 'Archetype'),
          value: containerRequirements.archetypeName,
        },
        {
          icon: <LengthIcon />,
          label: t('length', 'Length'),
          value: containerRequirements.containerLengths?.map(c => `${c}ft`).join(', '),
        },
        {
          icon: <HeightIcon />,
          label: t('height', 'Height'),
          value: containerRequirements.containerHeights?.map(height => t(height)).join(', '),
        },
        {
          label: t('type', 'Type'),
          value: containerRequirements.containerTypes?.map(type => t(type)).join(', '),
        },
      ]}
    />
  )
}
